export default {
  path: 'settings/roads',
  name: 'TemporaryRegulationsRoads',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/RoadsIndex.vue')
}
